module.exports = __webpack_public_path__ + "static/media/about19.fdb9cd59.webp";